// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inlineIframeContainer .iframeBubble {
  border-radius: 10px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
}

.chatBodyModal .failedIframe {
  padding: 28%;
  text-align: center;
  height: 100%;
  z-index: 999;
  background: white;
}

.inlineIframeContainer .iframeBubble {
  border-radius: 10px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
}

.uiformComponent {
  position: relative;
  min-height: 350px;
}

.uiformComponent #inlineIframeModal {
  width: 100%;
  height: 350px;
  background: none;
  border: none;
}

.uiformComponent #nlineIframeModal .closeForm {
  display: none;
}

.uiformComponent #nlineIframeModal .closeForm {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/iframeTemplate/iframeTemplate.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,iDAAA;AACJ;;AACA;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,mBAAA;EACA,iDAAA;AAGJ;;AADA;EACI,kBAAA;EACA,iBAAA;AAIJ;;AAFA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAKJ;;AAHA;EACI,aAAA;AAMJ;;AAJA;EACI,aAAA;AAOJ","sourcesContent":[".inlineIframeContainer .iframeBubble {\n    border-radius: 10px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n}\n.chatBodyModal .failedIframe {\n    padding: 28%;\n    text-align: center;\n    height: 100%;\n    z-index: 999;\n    background: white;\n}\n.inlineIframeContainer .iframeBubble {\n    border-radius: 10px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n}\n.uiformComponent {\n    position: relative;\n    min-height: 350px;\n}\n.uiformComponent #inlineIframeModal {\n    width: 100%;\n    height: 350px;\n    background: none;\n    border: none;\n}\n.uiformComponent #nlineIframeModal .closeForm {\n    display: none;\n}\n.uiformComponent #nlineIframeModal .closeForm {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
